import "./TheCCDModel.module.css";
import Header from "@/reusable_sections/Header";
import Methodology from "./sections/Methodology";
import Model from "./sections/Model";
import Capability from "./sections/Capability";
import Footer from "@/reusable_sections/Footer";
export default function TheCCDModelPage() {
  return <div>
      <Header />
      <Methodology />
      <Model />
      <Capability />
      <Footer />
    </div>;
}